import { defineMessages } from 'react-intl';

export default defineMessages({
  color: {
    id: 'ColorSelect.title',
    description: 'Title for the color selector',
    defaultMessage: 'Color: ',
  },
  kidsDisclaimer: {
    id: 'ColorSelect.kidsDisclaimer',
    description: 'Disclaimer for Kids Sheets on SoftStretch PDP',
    defaultMessage: 'This item fits a twin mattress but will display as “Kids Sheet” in your cart',
  },
});
